import type { FunctionComponent } from 'react';

import SubnavCountBadge from './SubnavCountBadge';
import SubnavItem from './SubnavItem';
import type { SubnavItemProps } from './SubnavItem';

export type SubnavItemWithCountProps = SubnavItemProps & {
  count: number;
  isLoading: boolean;
};

/**
 * SubnavItemWithCount is a SubnavComponent which additionally takes
 * a count prop, and renders the count in a badge (formatted properly)
 * to the right of whatever content you provide it with.
 */
const SubnavItemWithCount: FunctionComponent<SubnavItemWithCountProps> = ({
  children,
  to,
  navKey,
  openInNewTab,
  count,
  isLoading,
  testId,
}) => (
  <SubnavItem
    to={to}
    navKey={navKey}
    openInNewTab={openInNewTab}
    testId={testId}
  >
    {children}
    <SubnavCountBadge count={count} isLoading={isLoading} />
  </SubnavItem>
);

export default SubnavItemWithCount;
